import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = { class: "col-sm-4" }
const _hoisted_4 = {
  type: "submit",
  class: "btn btn-primary mx-1 mt-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormControlDatetime = _resolveComponent("FormControlDatetime")!
  const _component_FormControlInput = _resolveComponent("FormControlInput")!
  const _component_ValidationForm = _resolveComponent("ValidationForm")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_ValidationForm, { onSubmit: _ctx.setFilteredEvents }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_FormControlDatetime, {
            class: "col-sm-4",
            name: "startDate",
            label: _ctx.domainStore.translate('calendar.filter.startDate-label'),
            defaultvalue: _ctx.startDate
          }, null, 8, ["label", "defaultvalue"]),
          _hoisted_2,
          _createVNode(_component_FormControlDatetime, {
            class: "col-sm-4",
            name: "endDate",
            label: _ctx.domainStore.translate('calendar.filter.endDate-label'),
            defaultvalue: _ctx.endDate
          }, null, 8, ["label", "defaultvalue"]),
          (_ctx.filterText)
            ? (_openBlock(), _createBlock(_component_FormControlInput, {
                key: 0,
                name: "filterText",
                class: "col-sm-4",
                defaultvalue: _ctx.filterText
              }, null, 8, ["defaultvalue"]))
            : (_openBlock(), _createBlock(_component_FormControlInput, {
                key: 1,
                name: "filterText",
                class: "col-sm-4",
                placeholder: _ctx.domainStore.translate('calendar.filter.text-placeholder')
              }, null, 8, ["placeholder"])),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", _hoisted_4, _toDisplayString(_ctx.domainStore.translate('calendar.filter.submit')), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary mx-1 mt-1",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.resetFilter && _ctx.resetFilter(...args)))
            }, _toDisplayString(_ctx.domainStore.translate('calendar.filter.reset')), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["onSubmit"])
  ]))
}